var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIkeOfficeLogo = function SvgIkeOfficeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 213 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.285 16.207 16.213 68.21v104.008l90.072 52.002 90.072-52.002V68.21l-90.072-52.002Z",
    fill: "#14141C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.285 242.941 5.858 184.959l5.404-3.12 95.023 54.862 95.023-54.862 5.404 3.12-100.427 57.982ZM212.57 174.83l-5.404-3.121V61.969l-95.03-54.865V.864L212.57 58.85V174.83ZM5.404 171.709 0 174.83V58.849L100.434.865v6.239L5.404 61.97v109.739Z",
    fill: "#14141C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.263 135.814v-31.202l27.022-15.6V57.808L52.242 89.011v62.404l27.021-15.601Z",
    fill: "#4849B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m79.263 135.814 27.022 15.601 27.022-15.601 27.021 15.601-54.043 31.202-54.043-31.202 27.021-15.601Z",
    fill: "#393999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.307 135.814v-31.202l-27.022-15.6V57.808l54.043 31.202v62.404l-27.021-15.601Z",
    fill: "#5C5CE8"
  })));
};
export default SvgIkeOfficeLogo;